import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCheckbox,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonLoading,
  IonPage,
  IonRow,
  IonText,
  IonToast,
} from "@ionic/react";
import { pin } from "ionicons/icons";
import { InputMask } from "primereact/inputmask";
import React, { useEffect, useState } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Header from "../../components/Header";
import { AuthContext } from "../../providers/authContext";
import sorgulamaService from "../../services/SorgulamaService"; // requires a loader
import "./Page.css";

const DijitalFaturaBasvuru: React.FC = () => {
  const { setTitle, kurumBilgileri } = React.useContext(AuthContext);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<string>();
  const [tcNo, setTcNo] = useState<string>();
  const [aboneNo, setAboneNo] = useState<number>();
  const [verificationCode, setVerificationCode] = useState<string>();
  const [aggreed, setAggreed] = useState<boolean>(false);
  const [slidesMainIndex, setSlidesMainIndex] = useState(0);
  const [countDownKey, setCountDownKey] = useState<number>(0);
  const [verificationFailedMessage, setVerificationFailedMessage] =
    useState<string>();
  const [codeCountDownStarted, setCodeCountDownStarted] =
    useState<boolean>(false);

  useEffect(() => {
    setTitle("Dijital Fatura Talep Formu");
    setSlidesMainIndex(0);
    setCodeCountDownStarted(false);
  }, []);

  const showToast = (message: string) => {
    setVerificationFailedMessage(message);
  };

  const dogrula = () => {
    if (!tcNo) {
      showToast("T.C. Kimlik No bilgisi giriniz!");
      return;
    }
    if (tcNo.length !== 11) {
      showToast("Lütfen T.C Kimlik No Bilgisini Doğru Giriniz!");
      return;
    }
    if (!aboneNo) {
      showToast("Abone No bilgisi giriniz!");
      return;
    }
    if (!aggreed) {
      showToast("Lütfen Sözleşmeyi Onaylayınız!");
      return;
    }
    setShowLoading(true);
    sorgulamaService
      .dijitalFaturaBasvuruKoduAl(tcNo!, aboneNo!)
      .then(() => {
        setVerificationFailedMessage(undefined);
        setSlidesMainIndex(1);
        setCountDownKey((prevKey) => prevKey + 1);
        setCodeCountDownStarted(true);
      })
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          console.error(error.response.data);
          console.error(error.response.status);
          console.error(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.error(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error("Error", error.message);
        }
        showToast(error.response ? error.response.data.message : error);
      })
      .finally(() => setShowLoading(false));
  };

  const kodDogrula = () => {
    if (!verificationCode) {
      showToast("Lütfen Doğrulama Kodu Bilgisini Giriniz");
      return;
    }
    setShowLoading(true);
    sorgulamaService
      .dijitalFaturaKodDogrula(tcNo!, aboneNo!, verificationCode!)
      .then(() => {
        back();
        setShowToastMessage(
          "Talebiniz başarılı bir şekilde tarafımıza ulaştırılmıştır."
        );
      })
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          console.error(error.response.data);
          console.error(error.response.status);
          console.error(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.error(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error("Error", error.message);
        }
        const errMsg = error.response ? error.response.data.message : error;
        showToast(errMsg);
        if (errMsg.indexOf("tekrar kod") !== -1) {
          back();
        }
      })
      .finally(() => setShowLoading(false));
  };

  const back = () => {
    setVerificationFailedMessage(undefined);
    setTcNo(undefined);
    setAboneNo(undefined);
    setVerificationCode(undefined);
    setAggreed(false);
    setSlidesMainIndex(0);
    setCodeCountDownStarted(false);
  };

  return (
    <IonPage>
      <Header />
      <IonContent fullscreen>
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={"Lütfen Bekleyin..."}
        />
        <IonToast
          isOpen={showToastMessage !== undefined}
          onDidDismiss={() => setShowToastMessage(undefined)}
          message={showToastMessage}
          duration={2000}
          position="top"
        />
        <IonCard>
          <IonCardHeader>
            {verificationFailedMessage && (
              <IonItem>
                <IonText color="danger">{verificationFailedMessage}</IonText>
              </IonItem>
            )}
          </IonCardHeader>
          <IonCardContent>
            <Carousel
              key={`carousel-${slidesMainIndex}`}
              selectedItem={slidesMainIndex}
              infiniteLoop={false}
              showStatus={false}
              showArrows={false}
              swipeable={false}
              showIndicators={false}
              showThumbs={false}
            >
              <div>
                <IonGrid>
                  <IonRow>
                    <IonCol
                      size="4"
                      offset="0"
                      sizeSm="3"
                      offsetSm="1"
                      className="ion-hide-sm-down"
                    >
                      <IonItem className="ion-text-end">
                        <IonLabel>T.C. Kimlik No</IonLabel>
                      </IonItem>
                    </IonCol>
                    <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                      <IonItem className="ion-hide-sm-up">
                        <IonLabel position="floating">T.C. Kimlik No</IonLabel>
                        <IonInput
                          name="tcNoInput"
                          value={tcNo}
                          maxlength={11}
                          onIonChange={(e) => {
                            let val = e.detail.value;
                            if (val) {
                              return setTcNo(val);
                            }
                            return setTcNo(undefined);
                          }}
                          clearInput
                        />
                      </IonItem>
                      <IonItem className="ion-hide-sm-down">
                        <IonInput
                          name="tcNoInput"
                          value={tcNo}
                          maxlength={11}
                          placeholder="T.C. Kimlik No..."
                          onIonChange={(e) => {
                            let val = e.detail.value;
                            if (val) {
                              return setTcNo(val);
                            }
                            return setTcNo(undefined);
                          }}
                          clearInput
                        />
                      </IonItem>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol
                      size="4"
                      offset="0"
                      sizeSm="3"
                      offsetSm="1"
                      className="ion-hide-sm-down"
                    >
                      <IonItem className="ion-text-end">
                        <IonLabel>Abone No</IonLabel>
                      </IonItem>
                    </IonCol>
                    <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                      <IonItem className="ion-hide-sm-up">
                        <IonLabel position="floating">Abone No</IonLabel>
                        <IonInput
                          name="aboneNoInput"
                          value={aboneNo}
                          maxlength={11}
                          onIonChange={(e) => {
                            let val = e.detail.value;
                            if (val) {
                              return setAboneNo(parseInt(val));
                            }
                            return setAboneNo(undefined);
                          }}
                          clearInput
                        />
                      </IonItem>
                      <IonItem className="ion-hide-sm-down">
                        <IonInput
                          name="aboneNoInput"
                          value={aboneNo}
                          maxlength={11}
                          placeholder="Abone No..."
                          onIonChange={(e) => {
                            let val = e.detail.value;
                            if (val) {
                              return setAboneNo(parseInt(val));
                            }
                            return setAboneNo(undefined);
                          }}
                          clearInput
                        />
                      </IonItem>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol className="ion-text-justify">
                      <span style={{ fontSize: "13px" }}>
                        <b>Sayın Abonemiz,</b>
                      </span>
                      <br />
                      <br />
                      <span style={{ fontSize: "13px" }}>
                        Resmi Gazetede yayınlanan Abonelik Sözleşmeleri
                        Yönetmeliğinin 20 inci maddesine istinaden; fatura ve
                        ödeme bildirimlerinin kâğıt fatura olarak verilebileceği
                        gibi aynı zamanda <b>Kalıcı veri saklayıcısı</b>{" "}
                        (Tüketicinin gönderdiği veya kendisine gönderilen
                        bilgiyi, bu bilginin amacına uygun olarak makul bir süre
                        incelemesine elverecek şekilde kaydedilmesini ve
                        değiştirilmeden kopyalanmasını sağlayan ve bu bilgiye
                        aynen ulaşılmasına imkân veren{" "}
                        <b>kısa mesaj, elektronik posta</b> ) ile de
                        gönderebileceğine imkan vermiştir.
                      </span>
                      <br />
                      <br />
                      <ul>
                        <li style={{ fontSize: "13px", color: "Maroon" }}>
                          Seçtiğim adreslerdeki aboneliğime ait sözleşmeye kağıt
                          fatura yerine elektronik ortamda gönderilmesini
                          istiyorum.
                        </li>
                        <li style={{ fontSize: "13px" }}>
                          Fatura gönderilecek iletişim bilgilerimde değişiklik
                          olması halinde üç gün içerisinde{" "}
                          {kurumBilgileri?.kisaTanim}'ne bildireceğimi taahhüt
                          ederim. Bildirmediğim durumlarda sorumluluğun bana ait
                          olduğunu kabul ediyorum. Yukarıda yazılan bilgileri
                          okudum anladım kabul ediyorum.
                        </li>
                      </ul>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonItem>
                      <IonText>
                        <span style={{ fontSize: "15px" }}>
                          Sözleşmeyi okudum, kabul ediyorum.
                        </span>
                      </IonText>
                      <IonCheckbox
                        color="primary"
                        checked={aggreed}
                        slot="start"
                        onIonChange={(e) => setAggreed(e.detail.checked)}
                      ></IonCheckbox>
                    </IonItem>
                  </IonRow>
                  <IonRow>
                    <IonCol>
                      <IonButton type="button" onClick={() => dogrula()}>
                        Gönder
                      </IonButton>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </div>
              <div>
                <IonItem color="light">
                  <IonIcon icon={pin} slot="start" />
                  <IonLabel className="ion-text-wrap">
                    Telefonunuza gelen 4 haneli kodu aşağıdaki alana girip
                    Doğrula butonuna basınız.
                  </IonLabel>
                </IonItem>
                <IonGrid className="ion-padding-top">
                  <IonRow className="ion-align-items-center ion-justify-content-center">
                    <IonItem>
                      <IonLabel className="ion-padding-end">
                        Doğrulama Kodu
                      </IonLabel>
                      <InputMask
                        id="verificationCode"
                        mask="9999"
                        size={6}
                        unmask={true}
                        placeholder="Kod..."
                        tooltip="Telefonunuza gelen kod..."
                        value={verificationCode}
                        onChange={(e) => setVerificationCode(e.value)}
                      />
                      <span className="ion-padding">
                        <CountdownCircleTimer
                          isPlaying={codeCountDownStarted}
                          key={countDownKey}
                          duration={300}
                          colors="#7E2E84"
                          size={60}
                          strokeWidth={6}
                          children={({ remainingTime }) => {
                            if (!remainingTime) {
                              remainingTime = 0;
                            }
                            const minutes = Math.floor(remainingTime / 60);
                            const seconds = remainingTime % 60;

                            return `${minutes}:${seconds}`;
                          }}
                          onComplete={() => {
                            back();
                            return [false, 0];
                          }}
                        />
                      </span>
                    </IonItem>
                  </IonRow>
                  <IonRow className="ion-justify-content-center ion-padding-top">
                    <IonButton
                      onClick={() => kodDogrula()}
                      className="ion-padding-end"
                    >
                      Doğrula
                    </IonButton>
                    <IonButton
                      color="light"
                      onClick={() => {
                        back();
                      }}
                    >
                      Vazgeç
                    </IonButton>
                  </IonRow>
                </IonGrid>
              </div>
            </Carousel>
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export default DijitalFaturaBasvuru;
